module.exports = __webpack_public_path__ + "img/img_workspace_banner.041ae53c.png";